import { render, staticRenderFns } from "./GeneratedNotoInvoicePdfViewer.vue?vue&type=template&id=fcb2f43e&scoped=true&"
import script from "./GeneratedNotoInvoicePdfViewer.vue?vue&type=script&lang=ts&"
export * from "./GeneratedNotoInvoicePdfViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb2f43e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
